import Vue from 'vue';
import { gsap } from 'gsap';
import ProgressBar from 'progressbar.js';
import Swiper, { Pagination } from 'swiper';

Swiper.use([Pagination]);

Vue.component('story-slider-component', {
    props: ['totalSlides'],
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            swiper: null,
            sliderHolder: null,
            progressBar: null,
            cursor: null,
            cursorBox: null,
            cursorText: null,
            mouseToggleTl: null,
            mouseClickTl: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.sliderHolder = this.$el.querySelector('.story-slider');

        this.cursor = this.$el.querySelector('.story-slider__cursor-holder');
        this.cursorText = this.cursor.querySelector('.story-slider__cursor-text');

        this.initSwiper();

        EventBus.$on('window-resize', () => {
            this.initCursor();
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        mouseMoveEvent(e) {
            gsap.set(this.cursor, {
                x: e.clientX - (this.cursorBox ? this.cursorBox.width / 2 : 160 / 2),
                y: e.clientY - (this.cursorBox ? this.cursorBox.height / 2 : 160 / 2),
            });
        },

        mouseEnterEvent() {
            if (this.mouseToggleTl) {
                this.mouseToggleTl.kill();
            }

            this.mouseToggleTl = gsap.timeline();

            this.mouseToggleTl
                .to(this.cursor, {
                    duration: 0.5,
                    scale: 1,
                    ease: 'power4.out',
                });
        },

        mouseLeaveEvent() {
            if (this.mouseToggleTl) {
                this.mouseToggleTl.kill();
            }

            this.mouseToggleTl = gsap.timeline();

            this.mouseToggleTl
                .to(this.cursor, {
                    duration: 0.5,
                    scale: 0,
                    ease: 'power4.out',
                });
        },

        mouseUpEvent() {
            if (this.mouseClickTl) {
                this.mouseClickTl.kill();
            }

            this.mouseClickTl = gsap.timeline();

            this.mouseClickTl
                .to(this.cursor, {
                    duration: 0.5,
                    scale: 1,
                    ease: 'power3.out',
                })
                .to(this.cursorText, {
                    duration: 0.4,
                    autoAlpha: 1,
                    ease: 'power3.out',
                    onComplete: () => {
                        if (!this.cursorBox) {
                            this.cursorBox = this.cursor.getBoundingClientRect();
                        }
                    },
                }, '<+0.1');
        },

        mouseDownEvent() {
            if (this.mouseClickTl) {
                this.mouseClickTl.kill();
            }

            this.mouseClickTl = gsap.timeline();

            this.mouseClickTl
                .to(this.cursorText, {
                    duration: 0.4,
                    autoAlpha: 0,
                    ease: 'power3.out',
                })
                .to(this.cursor, {
                    duration: 0.5,
                    scale: 0.2,
                    ease: 'power3.out',
                }, '<');
        },

        initSwiper() {
            this.swiper = new Swiper(this.sliderHolder, {
                modules: [Pagination],
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                threshold: 5,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                slidesPerView: 1.1,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 1.85,
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerView: 2.15,
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerView: 2.15,
                    },
                    // when window width is >= 1440px
                    1440: {
                        slidesPerView: 2.15,
                    },
                    // when window width is >= 1920px
                    1920: {
                        slidesPerView: 2.2,
                    },
                },
            });

            this.swiper.on('touchStart', () => {
                this.mouseDownEvent();
            });

            this.swiper.on('touchEnd', () => {
                this.mouseUpEvent();
            });

            this.$nextTick(() => {
                this.initProgressCircle();
            });
        },

        initProgressCircle() {
            this.progressBar = new ProgressBar.Circle('.story-slider__progress', {
                strokeWidth: 2,
                easing: 'easeInOut',
                duration: 1400,
                color: '#fafafa',
                trailColor: '#fafafa4d',
                trailWidth: 1,
                svgStyle: null,
            });

            this.progressBar.animate((this.swiper.realIndex + 1) / this.totalSlides);

            this.swiper.on('slideChange', (e) => {
                this.progressBar.animate((e.realIndex + 1) / this.totalSlides);
            });
        },
    },

    beforeDestroy() {
    },
});
